import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const MATCH_COLORS: Record<string, string> = {
  matched: '#10b981', unmatched: '#f59e0b', manual: '#3b82f6',
};

export default function ReconciliationPage() {
  const [transactions, setTransactions] = useState<any[]>([]);
  const [debts, setDebts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState<'transactions' | 'debts'>('transactions');
  const [matchForm, setMatchForm] = useState({ transaction_id: '', invoice_id: '' });

  useEffect(() => {
    Promise.all([
      api.get('/admin/reconciliation/unmatched').catch(() => []),
      api.get('/admin/debts').catch(() => []),
    ]).then(([t, d]) => {
      setTransactions(t || []);
      setDebts(d || []);
    }).finally(() => setLoading(false));
  }, []);

  const autoMatch = async () => {
    await api.post('/admin/reconciliation/match');
    const t = await api.get('/admin/reconciliation/unmatched').catch(() => []);
    setTransactions(t || []);
  };

  const manualMatch = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/admin/reconciliation/match', matchForm);
    setMatchForm({ transaction_id: '', invoice_id: '' });
    const t = await api.get('/admin/reconciliation/unmatched').catch(() => []);
    setTransactions(t || []);
  };

  const checkOverdue = async () => {
    await api.post('/admin/debts/check-overdue');
    const d = await api.get('/admin/debts').catch(() => []);
    setDebts(d || []);
  };

  if (loading) return <p style={{ padding: 20 }}>Уншиж байна...</p>;

  return (
    <div>
      <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22', marginBottom: 16 }}>Тулгалт & Өр</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        <TabBtn active={tab === 'transactions'} onClick={() => setTab('transactions')}>
          Гүйлгээ ({transactions.length})
        </TabBtn>
        <TabBtn active={tab === 'debts'} onClick={() => setTab('debts')}>
          Өр ({debts.length})
        </TabBtn>
      </div>

      {tab === 'transactions' ? (
        <div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
            <button onClick={autoMatch} style={btnPrimary}>Автомат тулгалт</button>
          </div>
          <div style={{ ...card, marginBottom: 16 }}>
            <h4 style={{ marginBottom: 12 }}>Гар тулгалт</h4>
            <form onSubmit={manualMatch} style={{ display: 'flex', gap: 12, alignItems: 'end' }}>
              <div>
                <label style={labelStyle}>Гүйлгээний ID</label>
                <input value={matchForm.transaction_id} onChange={e => setMatchForm({ ...matchForm, transaction_id: e.target.value })} style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Нэхэмжлэхийн ID</label>
                <input value={matchForm.invoice_id} onChange={e => setMatchForm({ ...matchForm, invoice_id: e.target.value })} style={inputStyle} />
              </div>
              <button type="submit" style={btnPrimary}>Тулгах</button>
            </form>
          </div>
          <div style={card}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                  <th style={th}>Огноо</th>
                  <th style={th}>Дүн</th>
                  <th style={th}>Тайлбар</th>
                  <th style={th}>Лавлах</th>
                  <th style={th}>Статус</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((t: any) => (
                  <tr key={t.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                    <td style={td}>{new Date(t.transaction_date).toLocaleDateString()}</td>
                    <td style={td}>₮{(t.amount ?? 0).toLocaleString()}</td>
                    <td style={td}>{t.description || '-'}</td>
                    <td style={td}>{t.reference || '-'}</td>
                    <td style={td}>
                      <span style={{
                        background: (MATCH_COLORS[t.match_status] || '#6b7280') + '20',
                        color: MATCH_COLORS[t.match_status] || '#6b7280',
                        padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
                      }}>{t.match_status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <div style={{ marginBottom: 16 }}>
            <button onClick={checkOverdue} style={btnPrimary}>Хугацаа хэтэрсэн шалгах</button>
          </div>
          <div style={card}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                  <th style={th}>Оршин суугч</th>
                  <th style={th}>Нэхэмжлэх</th>
                  <th style={th}>Дүн</th>
                  <th style={th}>Хугацаа хэтэрсэн өдөр</th>
                  <th style={th}>Статус</th>
                </tr>
              </thead>
              <tbody>
                {debts.map((d: any) => (
                  <tr key={d.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                    <td style={td}>{d.resident_name || '-'}</td>
                    <td style={td}>{d.invoice_number || '-'}</td>
                    <td style={td}>₮{(d.amount ?? 0).toLocaleString()}</td>
                    <td style={td}>{d.days_overdue ?? 0} өдөр</td>
                    <td style={td}>
                      <span style={{
                        background: d.status === 'active' ? '#ef444420' : '#10b98120',
                        color: d.status === 'active' ? '#ef4444' : '#10b981',
                        padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
                      }}>{d.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function TabBtn({ active, onClick, children }: { active: boolean; onClick: () => void; children: React.ReactNode }) {
  return (
    <button onClick={onClick} style={{
      padding: '8px 16px', border: 'none', borderRadius: 6, cursor: 'pointer',
      background: active ? '#236844' : '#e8e5dc', color: active ? '#fff' : '#2a3b32',
      fontWeight: 600, fontSize: 14,
    }}>{children}</button>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
